export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-500-abcf7cd8c9dfb7a3dc42be27ae3c886e.ttf";